export const REQUEST_COURT_FORM_URL = 'https://forms.gle/bW2WFVXKArn58QNf9';
